export default "__VITE_ASSET__uZYHdlbt__"